/**
 * 获取URL参数
 * @param variable
 * @returns {string|boolean}
 */
export function getQueryVariable(variable) {
    if (window.location.href.indexOf('?') != -1) {
        var query = window.location.href.split('?')[1];
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            if (pair[0] == variable) {
                return pair[1];
            }
        }
    }
    return (false);
}

/**
 * 获取全局颜色
 * @param {*} key
 * @returns
 */
export function getSkin(key) {
    // 找到根部容器或局部容器
    const dom = document.querySelector('#dashboardLayout');
    return getComputedStyle(
        // 顶部容器不存在，则选择网页文档根元素
        dom ? dom : document.documentElement,
    ).getPropertyValue(key);
}



// WEBPACK FOOTER //
// ./src/utils/comment.js